/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Sug_ContactInputs */

const en_chat_sug_contact = /** @type {(inputs: Chat_Sug_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to contact?`)
};

const ar_chat_sug_contact = /** @type {(inputs: Chat_Sug_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كيف أتواصل؟`)
};

const bn_chat_sug_contact = /** @type {(inputs: Chat_Sug_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`যোগাযোগ করব কীভাবে?`)
};

const de_chat_sug_contact = /** @type {(inputs: Chat_Sug_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie kann ich Kontakt aufnehmen?`)
};

const es_chat_sug_contact = /** @type {(inputs: Chat_Sug_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo contactar?`)
};

const fr_chat_sug_contact = /** @type {(inputs: Chat_Sug_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment contacter ?`)
};

const pt_chat_sug_contact = /** @type {(inputs: Chat_Sug_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como entrar em contato?`)
};

const zh_chat_sug_contact = /** @type {(inputs: Chat_Sug_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何联系？`)
};

const tr_chat_sug_contact = /** @type {(inputs: Chat_Sug_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasıl iletişime geçilir?`)
};

const ru_chat_sug_contact = /** @type {(inputs: Chat_Sug_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как связаться?`)
};

const pl_chat_sug_contact = /** @type {(inputs: Chat_Sug_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak się skontaktować?`)
};

/**
* | output |
* | --- |
* | "How to contact?" |
*
* @param {Chat_Sug_ContactInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const chat_sug_contact = /** @type {((inputs?: Chat_Sug_ContactInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Sug_ContactInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_chat_sug_contact(inputs)
	if (locale === "bn") return bn_chat_sug_contact(inputs)
	if (locale === "de") return de_chat_sug_contact(inputs)
	if (locale === "es") return es_chat_sug_contact(inputs)
	if (locale === "fr") return fr_chat_sug_contact(inputs)
	if (locale === "pt") return pt_chat_sug_contact(inputs)
	if (locale === "zh") return zh_chat_sug_contact(inputs)
	if (locale === "tr") return tr_chat_sug_contact(inputs)
	if (locale === "ru") return ru_chat_sug_contact(inputs)
	if (locale === "pl") return pl_chat_sug_contact(inputs)
	return en_chat_sug_contact(inputs)
});